export default ``



// WEBPACK FOOTER //
// ./src/iframe/src/blank.js